const countries = [
    { code: 'AD', value: 'AND', label: 'Andorra', phone: '376' },
    { code: 'AE', value: 'ARE', label: 'United Arab Emirates', phone: '971' },
    { code: 'AF', value: 'AFG', label: 'Afghanistan', phone: '93' },
    { code: 'AG', value: 'ATG', label: 'Antigua and Barbuda', phone: '1-268' },
    { code: 'AI', value: 'AIA', label: 'Anguilla', phone: '1-264' },
    { code: 'AL', value: 'ALB', label: 'Albania', phone: '355' },
    { code: 'AM', value: 'ARM', label: 'Armenia', phone: '374' },
    { code: 'AO', value: 'AGO', label: 'Angola', phone: '244' },
    { code: 'AQ', value: 'ATA', label: 'Antarctica', phone: '672' },
    { code: 'AR', value: 'ARG', label: 'Argentina', phone: '54' },
    { code: 'AS', value: 'ASM', label: 'American Samoa', phone: '1-684' },
    { code: 'AT', value: 'AUT', label: 'Austria', phone: '43' },
    { code: 'AU', value: 'AUS', label: 'Australia', phone: '61' },
    { code: 'AW', value: 'ABW', label: 'Aruba', phone: '297' },
    { code: 'AX', value: 'ALA', label: 'Alland Islands', phone: '358' },
    { code: 'AZ', value: 'AZE', label: 'Azerbaijan', phone: '994' },
    { code: 'BA', value: 'BIH', label: 'Bosnia and Herzegovina', phone: '387' },
    { code: 'BB', value: 'BRB', label: 'Barbados', phone: '1-246' },
    { code: 'BD', value: 'BGD', label: 'Bangladesh', phone: '880' },
    { code: 'BE', value: 'BEL', label: 'Belgium', phone: '32' },
    { code: 'BF', value: 'BFA', label: 'Burkina Faso', phone: '226' },
    { code: 'BG', value: 'BGR', label: 'Bulgaria', phone: '359' },
    { code: 'BH', value: 'BHR', label: 'Bahrain', phone: '973' },
    { code: 'BI', value: 'BDI', label: 'Burundi', phone: '257' },
    { code: 'BJ', value: 'BEN', label: 'Benin', phone: '229' },
    { code: 'BL', value: 'BLM', label: 'Saint Barthelemy', phone: '590' },
    { code: 'BM', value: 'BMU', label: 'Bermuda', phone: '1-441' },
    { code: 'BN', value: 'BRN', label: 'Brunei Darussalam', phone: '673' },
    { code: 'BO', value: 'BOL', label: 'Bolivia', phone: '591' },
    { code: 'BR', value: 'BRA', label: 'Brazil', phone: '55' },
    { code: 'BS', value: 'BHS', label: 'Bahamas', phone: '1-242' },
    { code: 'BT', value: 'BTN', label: 'Bhutan', phone: '975' },
    { code: 'BV', value: 'BVT', label: 'Bouvet Island', phone: '47' },
    { code: 'BW', value: 'BWA', label: 'Botswana', phone: '267' },
    { code: 'BY', value: 'BLR', label: 'Belarus', phone: '375' },
    { code: 'BZ', value: 'BLZ', label: 'Belize', phone: '501' },
    { code: 'CA', value: 'CAN', label: 'Canada', phone: '1' },
    { code: 'CC', value: 'CCK', label: 'Cocos (Keeling) Islands', phone: '61' },
    { code: 'CD', value: 'COD', label: 'Congo, Democratic Republic of the', phone: '243' },
    { code: 'CF', value: 'CAF', label: 'Central African Republic', phone: '236' },
    { code: 'CG', value: 'COG', label: 'Congo, Republic of the', phone: '242' },
    { code: 'CH', value: 'CHE', label: 'Switzerland', phone: '41' },
    { code: 'CI', value: 'CIV', label: "Cote d'Ivoire", phone: '225' },
    { code: 'CK', value: 'COK', label: 'Cook Islands', phone: '682' },
    { code: 'CL', value: 'CHL', label: 'Chile', phone: '56' },
    { code: 'CM', value: 'CMR', label: 'Cameroon', phone: '237' },
    { code: 'CN', value: 'CHN', label: 'China', phone: '86' },
    { code: 'CO', value: 'COL', label: 'Colombia', phone: '57' },
    { code: 'CR', value: 'CRI', label: 'Costa Rica', phone: '506' },
    { code: 'CU', value: 'CUB', label: 'Cuba', phone: '53' },
    { code: 'CV', value: 'CPV', label: 'Cape Verde', phone: '238' },
    { code: 'CW', value: 'CUW', label: 'Curacao', phone: '599' },
    { code: 'CX', value: 'CXR', label: 'Christmas Island', phone: '61' },
    { code: 'CY', value: 'CYP', label: 'Cyprus', phone: '357' },
    { code: 'CZ', value: 'CZE', label: 'Czech Republic', phone: '420' },
    { code: 'DE', value: 'DEU', label: 'Germany', phone: '49' },
    { code: 'DJ', value: 'DJI', label: 'Djibouti', phone: '253' },
    { code: 'DK', value: 'DNK', label: 'Denmark', phone: '45' },
    { code: 'DM', value: 'DMA', label: 'Dominica', phone: '1-767' },
    { code: 'DO', value: 'DOM', label: 'Dominican Republic', phone: '1-809' },
    { code: 'DZ', value: 'DZA', label: 'Algeria', phone: '213' },
    { code: 'EC', value: 'ECU', label: 'Ecuador', phone: '593' },
    { code: 'EE', value: 'EST', label: 'Estonia', phone: '372' },
    { code: 'EG', value: 'EGY', label: 'Egypt', phone: '20' },
    { code: 'EH', value: 'ESH', label: 'Western Sahara', phone: '212' },
    { code: 'ER', value: 'ERI', label: 'Eritrea', phone: '291' },
    { code: 'ES', value: 'ESP', label: 'Spain', phone: '34' },
    { code: 'ET', value: 'ETH', label: 'Ethiopia', phone: '251' },
    { code: 'FI', value: 'FIN', label: 'Finland', phone: '358' },
    { code: 'FJ', value: 'FJI', label: 'Fiji', phone: '679' },
    { code: 'FK', value: 'FLK', label: 'Falkland Islands (Malvinas)', phone: '500' },
    { code: 'FM', value: 'FSM', label: 'Micronesia, Federated States of', phone: '691' },
    { code: 'FO', value: 'FRO', label: 'Faroe Islands', phone: '298' },
    { code: 'FR', value: 'FRA', label: 'France', phone: '33' },
    { code: 'GA', value: 'GAB', label: 'Gabon', phone: '241' },
    { code: 'GB', value: 'GBR', label: 'United Kingdom', phone: '44' },
    { code: 'GD', value: 'GRD', label: 'Grenada', phone: '1-473' },
    { code: 'GE', value: 'GEO', label: 'Georgia', phone: '995' },
    { code: 'GF', value: 'GUF', label: 'French Guiana', phone: '594' },
    { code: 'GG', value: 'GGY', label: 'Guernsey', phone: '44' },
    { code: 'GH', value: 'GHA', label: 'Ghana', phone: '233' },
    { code: 'GI', value: 'GIB', label: 'Gibraltar', phone: '350' },
    { code: 'GL', value: 'GRL', label: 'Greenland', phone: '299' },
    { code: 'GM', value: 'GMB', label: 'Gambia', phone: '220' },
    { code: 'GN', value: 'GIN', label: 'Guinea', phone: '224' },
    { code: 'GP', value: 'GLP', label: 'Guadeloupe', phone: '590' },
    { code: 'GQ', value: 'GNQ', label: 'Equatorial Guinea', phone: '240' },
    { code: 'GR', value: 'GRC', label: 'Greece', phone: '30' },
    { code: 'GS', value: 'SGS', label: 'South Georgia and the South Sandwich Islands', phone: '500' },
    { code: 'GT', value: 'GTM', label: 'Guatemala', phone: '502' },
    { code: 'GU', value: 'GUM', label: 'Guam', phone: '1-671' },
    { code: 'GW', value: 'GNB', label: 'Guinea-Bissau', phone: '245' },
    { code: 'GY', value: 'GUY', label: 'Guyana', phone: '592' },
    { code: 'HK', value: 'HKG', label: 'Hong Kong', phone: '852' },
    { code: 'HM', value: 'HMD', label: 'Heard Island and McDonald Islands', phone: '672' },
    { code: 'HN', value: 'HND', label: 'Honduras', phone: '504' },
    { code: 'HR', value: 'HRV', label: 'Croatia', phone: '385' },
    { code: 'HT', value: 'HTI', label: 'Haiti', phone: '509' },
    { code: 'HU', value: 'HUN', label: 'Hungary', phone: '36' },
    { code: 'ID', value: 'IDN', label: 'Indonesia', phone: '62' },
    { code: 'IE', value: 'IRL', label: 'Ireland', phone: '353' },
    { code: 'IL', value: 'ISR', label: 'Israel', phone: '972' },
    { code: 'IM', value: 'IMN', label: 'Isle of Man', phone: '44' },
    { code: 'IN', value: 'IND', label: 'India', phone: '91' },
    { code: 'IO', value: 'IOT', label: 'British Indian Ocean Territory', phone: '246' },
    { code: 'IQ', value: 'IRQ', label: 'Iraq', phone: '964' },
    { code: 'IR', value: 'IRN', label: 'Iran, Islamic Republic of', phone: '98' },
    { code: 'IS', value: 'ISL', label: 'Iceland', phone: '354' },
    { code: 'IT', value: 'ITA', label: 'Italy', phone: '39' },
    { code: 'JE', value: 'JEY', label: 'Jersey', phone: '44' },
    { code: 'JM', value: 'JAM', label: 'Jamaica', phone: '1-876' },
    { code: 'JO', value: 'JOR', label: 'Jordan', phone: '962' },
    { code: 'JP', value: 'JPN', label: 'Japan', phone: '81' },
    { code: 'KE', value: 'KEN', label: 'Kenya', phone: '254' },
    { code: 'KG', value: 'KGZ', label: 'Kyrgyzstan', phone: '996' },
    { code: 'KH', value: 'KHM', label: 'Cambodia', phone: '855' },
    { code: 'KI', value: 'KIR', label: 'Kiribati', phone: '686' },
    { code: 'KM', value: 'COM', label: 'Comoros', phone: '269' },
    { code: 'KN', value: 'KNA', label: 'Saint Kitts and Nevis', phone: '1-869' },
    { code: 'KP', value: 'PRK', label: "Korea, Democratic People's Republic of", phone: '850' },
    { code: 'KR', value: 'KOR', label: 'Korea, Republic of', phone: '82' },
    { code: 'KW', value: 'KWT', label: 'Kuwait', phone: '965' },
    { code: 'KY', value: 'CYM', label: 'Cayman Islands', phone: '1-345' },
    { code: 'KZ', value: 'KAZ', label: 'Kazakhstan', phone: '7' },
    { code: 'LA', value: 'LAO', label: "Lao People's Democratic Republic", phone: '856' },
    { code: 'LB', value: 'LBN', label: 'Lebanon', phone: '961' },
    { code: 'LC', value: 'LCA', label: 'Saint Lucia', phone: '1-758' },
    { code: 'LI', value: 'LIE', label: 'Liechtenstein', phone: '423' },
    { code: 'LK', value: 'LKA', label: 'Sri Lanka', phone: '94' },
    { code: 'LR', value: 'LBR', label: 'Liberia', phone: '231' },
    { code: 'LS', value: 'LSO', label: 'Lesotho', phone: '266' },
    { code: 'LT', value: 'LTU', label: 'Lithuania', phone: '370' },
    { code: 'LU', value: 'LUX', label: 'Luxembourg', phone: '352' },
    { code: 'LV', value: 'LVA', label: 'Latvia', phone: '371' },
    { code: 'LY', value: 'LBY', label: 'Libya', phone: '218' },
    { code: 'MA', value: 'MAR', label: 'Morocco', phone: '212' },
    { code: 'MC', value: 'MCO', label: 'Monaco', phone: '377' },
    { code: 'MD', value: 'MDA', label: 'Moldova, Republic of', phone: '373' },
    { code: 'ME', value: 'MNE', label: 'Montenegro', phone: '382' },
    { code: 'MF', value: 'MAF', label: 'Saint Martin (French part)', phone: '590' },
    { code: 'MG', value: 'MDG', label: 'Madagascar', phone: '261' },
    { code: 'MH', value: 'MHL', label: 'Marshall Islands', phone: '692' },
    { code: 'MK', value: 'MKD', label: 'Macedonia, the Former Yugoslav Republic of', phone: '389' },
    { code: 'ML', value: 'MLI', label: 'Mali', phone: '223' },
    { code: 'MM', value: 'MMR', label: 'Myanmar', phone: '95' },
    { code: 'MN', value: 'MNG', label: 'Mongolia', phone: '976' },
    { code: 'MO', value: 'MAC', label: 'Macao', phone: '853' },
    { code: 'MP', value: 'MNP', label: 'Northern Mariana Islands', phone: '1-670' },
    { code: 'MQ', value: 'MTQ', label: 'Martinique', phone: '596' },
    { code: 'MR', value: 'MRT', label: 'Mauritania', phone: '222' },
    { code: 'MS', value: 'MSR', label: 'Montserrat', phone: '1-664' },
    { code: 'MT', value: 'MLT', label: 'Malta', phone: '356' },
    { code: 'MU', value: 'MUS', label: 'Mauritius', phone: '230' },
    { code: 'MV', value: 'MDV', label: 'Maldives', phone: '960' },
    { code: 'MW', value: 'MWI', label: 'Malawi', phone: '265' },
    { code: 'MX', value: 'MEX', label: 'Mexico', phone: '52' },
    { code: 'MY', value: 'MYS', label: 'Malaysia', phone: '60' },
    { code: 'MZ', value: 'MOZ', label: 'Mozambique', phone: '258' },
    { code: 'NA', value: 'NAM', label: 'Namibia', phone: '264' },
    { code: 'NC', value: 'NCL', label: 'New Caledonia', phone: '687' },
    { code: 'NE', value: 'NER', label: 'Niger', phone: '227' },
    { code: 'NF', value: 'NFK', label: 'Norfolk Island', phone: '672' },
    { code: 'NG', value: 'NGA', label: 'Nigeria', phone: '234' },
    { code: 'NI', value: 'NIC', label: 'Nicaragua', phone: '505' },
    { code: 'NL', value: 'NLD', label: 'Netherlands', phone: '31' },
    { code: 'NO', value: 'NOR', label: 'Norway', phone: '47' },
    { code: 'NP', value: 'NPL', label: 'Nepal', phone: '977' },
    { code: 'NR', value: 'NRU', label: 'Nauru', phone: '674' },
    { code: 'NU', value: 'NIU', label: 'Niue', phone: '683' },
    { code: 'NZ', value: 'NZL', label: 'New Zealand', phone: '64' },
    { code: 'OM', value: 'OMN', label: 'Oman', phone: '968' },
    { code: 'PA', value: 'PAN', label: 'Panama', phone: '507' },
    { code: 'PE', value: 'PER', label: 'Peru', phone: '51' },
    { code: 'PF', value: 'PYF', label: 'French Polynesia', phone: '689' },
    { code: 'PG', value: 'PNG', label: 'Papua New Guinea', phone: '675' },
    { code: 'PH', value: 'PHL', label: 'Philippines', phone: '63' },
    { code: 'PK', value: 'PAK', label: 'Pakistan', phone: '92' },
    { code: 'PL', value: 'POL', label: 'Poland', phone: '48' },
    { code: 'PM', value: 'SPM', label: 'Saint Pierre and Miquelon', phone: '508' },
    { code: 'PN', value: 'PCN', label: 'Pitcairn', phone: '870' },
    { code: 'PR', value: 'PRI', label: 'Puerto Rico', phone: '1' },
    { code: 'PS', value: 'PSE', label: 'Palestine, State of', phone: '970' },
    { code: 'PT', value: 'PRT', label: 'Portugal', phone: '351' },
    { code: 'PW', value: 'PLW', label: 'Palau', phone: '680' },
    { code: 'PY', value: 'PRY', label: 'Paraguay', phone: '595' },
    { code: 'QA', value: 'QAT', label: 'Qatar', phone: '974' },
    { code: 'RE', value: 'REU', label: 'Reunion', phone: '262' },
    { code: 'RO', value: 'ROU', label: 'Romania', phone: '40' },
    { code: 'RS', value: 'SRB', label: 'Serbia', phone: '381' },
    { code: 'RU', value: 'RUS', label: 'Russian Federation', phone: '7' },
    { code: 'RW', value: 'RWA', label: 'Rwanda', phone: '250' },
    { code: 'SA', value: 'SAU', label: 'Saudi Arabia', phone: '966' },
    { code: 'SB', value: 'SLB', label: 'Solomon Islands', phone: '677' },
    { code: 'SC', value: 'SYC', label: 'Seychelles', phone: '248' },
    { code: 'SD', value: 'SDN', label: 'Sudan', phone: '249' },
    { code: 'SE', value: 'SWE', label: 'Sweden', phone: '46' },
    { code: 'SG', value: 'SGP', label: 'Singapore', phone: '65' },
    { code: 'SH', value: 'SHN', label: 'Saint Helena', phone: '290' },
    { code: 'SI', value: 'SVN', label: 'Slovenia', phone: '386' },
    { code: 'SJ', value: 'SJM', label: 'Svalbard and Jan Mayen', phone: '47' },
    { code: 'SK', value: 'SVK', label: 'Slovakia', phone: '421' },
    { code: 'SL', value: 'SLE', label: 'Sierra Leone', phone: '232' },
    { code: 'SM', value: 'SMR', label: 'San Marino', phone: '378' },
    { code: 'SN', value: 'SEN', label: 'Senegal', phone: '221' },
    { code: 'SO', value: 'SOM', label: 'Somalia', phone: '252' },
    { code: 'SR', value: 'SUR', label: 'Suriname', phone: '597' },
    { code: 'SS', value: 'SSD', label: 'South Sudan', phone: '211' },
    { code: 'ST', value: 'STP', label: 'Sao Tome and Principe', phone: '239' },
    { code: 'SV', value: 'SLV', label: 'El Salvador', phone: '503' },
    { code: 'SX', value: 'SXM', label: 'Sint Maarten (Dutch part)', phone: '1-721' },
    { code: 'SY', value: 'SYR', label: 'Syrian Arab Republic', phone: '963' },
    { code: 'SZ', value: 'SWZ', label: 'Swaziland', phone: '268' },
    { code: 'TC', value: 'TCA', label: 'Turks and Caicos Islands', phone: '1-649' },
    { code: 'TD', value: 'TCD', label: 'Chad', phone: '235' },
    { code: 'TF', value: 'ATF', label: 'French Southern Territories', phone: '262' },
    { code: 'TG', value: 'TGO', label: 'Togo', phone: '228' },
    { code: 'TH', value: 'THA', label: 'Thailand', phone: '66' },
    { code: 'TJ', value: 'TJK', label: 'Tajikistan', phone: '992' },
    { code: 'TK', value: 'TKL', label: 'Tokelau', phone: '690' },
    { code: 'TL', value: 'TLS', label: 'Timor-Leste', phone: '670' },
    { code: 'TM', value: 'TKM', label: 'Turkmenistan', phone: '993' },
    { code: 'TN', value: 'TUN', label: 'Tunisia', phone: '216' },
    { code: 'TO', value: 'TON', label: 'Tonga', phone: '676' },
    { code: 'TR', value: 'TUR', label: 'Turkey', phone: '90' },
    { code: 'TT', value: 'TTO', label: 'Trinidad and Tobago', phone: '1-868' },
    { code: 'TV', value: 'TUV', label: 'Tuvalu', phone: '688' },
    { code: 'TW', value: 'TWN', label: 'Taiwan, Province of China', phone: '886' },
    { code: 'TZ', value: 'TZA', label: 'United Republic of Tanzania', phone: '255' },
    { code: 'UA', value: 'UKR', label: 'Ukraine', phone: '380' },
    { code: 'UG', value: 'UGA', label: 'Uganda', phone: '256' },
    { code: 'US', value: 'USA', label: 'United States', phone: '1' },
    { code: 'UY', value: 'URY', label: 'Uruguay', phone: '598' },
    { code: 'UZ', value: 'UZB', label: 'Uzbekistan', phone: '998' },
    { code: 'VA', value: 'VAT', label: 'Holy See (Vatican City State)', phone: '379' },
    { code: 'VC', value: 'VCT', label: 'Saint Vincent and the Grenadines', phone: '1-784' },
    { code: 'VE', value: 'VEN', label: 'Venezuela', phone: '58' },
    { code: 'VG', value: 'VGB', label: 'British Virgin Islands', phone: '1-284' },
    { code: 'VI', value: 'VIR', label: 'US Virgin Islands', phone: '1-340' },
    { code: 'VN', value: 'VNM', label: 'Vietnam', phone: '84' },
    { code: 'VU', value: 'VUT', label: 'Vanuatu', phone: '678' },
    { code: 'WF', value: 'WLF', label: 'Wallis and Futuna', phone: '681' },
    { code: 'WS', value: 'WSM', label: 'Samoa', phone: '685' },
    { code: 'XK', value: 'XKK', label: 'Kosovo', phone: '383' },
    { code: 'YE', value: 'YEM', label: 'Yemen', phone: '967' },
    { code: 'YT', value: 'MYT', label: 'Mayotte', phone: '262' },
    { code: 'ZA', value: 'ZAF', label: 'South Africa', phone: '27' },
    { code: 'ZM', value: 'ZMB', label: 'Zambia', phone: '260' },
    { code: 'ZW', value: 'ZWE', label: 'Zimbabwe', phone: '263' },
];

export default countries